<div class="flex items-center gap-1 pb-2">
  <div class="min-w-0 flex-1">
    <button
      type="button"
      class="flex h-8 max-w-full cursor-pointer items-center gap-1 rounded-mib px-2 text-sm font-semibold text-gray-900 hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-mib-primary"
      aria-live="polite"
      [attr.aria-expanded]="view() !== 'month'"
      (click)="switchView()">
      <span class="truncate">{{ title() }}</span>
      <svg mib-icon name="chevron-down" class="size-4 text-gray-500" [class.rotate-180]="view() !== 'month'"></svg>
    </button>
  </div>
  <button
    class="mib-field-action"
    type="button"
    [disabled]="!canGoBack()"
    [attr.aria-label]="previousLabel()"
    (click)="previous()">
    <svg mib-icon name="chevron-left" class="size-4"></svg>
  </button>
  <button
    class="mib-field-action"
    type="button"
    [disabled]="!canGoForward()"
    [attr.aria-label]="nextLabel()"
    (click)="next()">
    <svg mib-icon name="chevron-right" class="size-4"></svg>
  </button>
</div>

@if (view() !== 'month') {
  <div ngGrid enableSelection selectionMode="explicit" [attr.aria-label]="title()" class="flex flex-col gap-1 pt-1">
    @for (row of choices(); track $index) {
      <div ngGridRow class="grid grid-cols-4 gap-1">
        @for (choice of row; track choice.key) {
          <div
            ngGridCell
            class="group flex h-9 items-center justify-center outline-none"
            [class.cursor-pointer]="!choice.disabled"
            [disabled]="choice.disabled"
            [selected]="choice.selected"
            [attr.data-mib-date]="choice.key"
            (click)="choose(choice)"
            (keydown)="onChoiceKeydown($event, choice)">
            <span
              class="flex h-8 w-full items-center justify-center rounded-full text-sm group-focus-visible:outline-2 group-focus-visible:outline-offset-1 group-focus-visible:outline-mib-primary"
              [class.bg-mib-primary]="choice.selected"
              [class.text-white]="choice.selected"
              [class.font-semibold]="choice.current || choice.selected"
              [class.border]="choice.current && !choice.selected"
              [class.border-mib-primary]="choice.current && !choice.selected"
              [class.text-mib-primary]="choice.current && !choice.selected"
              [class.text-gray-900]="!choice.current && !choice.selected && !choice.disabled"
              [class.text-gray-500]="choice.disabled"
              [class.hover:bg-gray-100]="!choice.selected && !choice.disabled"
              >{{ choice.label }}</span
            >
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div
    ngGrid
    enableSelection
    selectionMode="explicit"
    [multi]="range()"
    [attr.aria-label]="title()"
    class="flex flex-col"
    (pointerleave)="hovered.set(null)">
    <div ngGridRow class="grid grid-cols-7">
      @for (weekday of weekdays(); track $index) {
        <div ngGridCell role="columnheader" class="flex h-8 items-center justify-center text-xs/4.5 text-gray-500">
          <abbr class="no-underline" [title]="weekday.long">{{ weekday.short }}</abbr>
        </div>
      }
    </div>
    @for (week of weeks(); track $index) {
      <div ngGridRow class="grid grid-cols-7">
        @for (cell of week; track cell.key) {
          @if (cell.inMonth) {
            <div
              ngGridCell
              class="group flex h-9 items-center justify-center outline-none"
              [class.bg-mib-indigo-50]="cell.inRange"
              [class.mib-date-band-start]="cell.rangeStart && !cell.rangeEnd && (drawnEnd() || hovered())"
              [class.mib-date-band-end]="cell.rangeEnd && !cell.rangeStart"
              [class.cursor-pointer]="!cell.disabled"
              [disabled]="cell.disabled"
              [selected]="cell.selected"
              [attr.aria-label]="label(cell)"
              [attr.aria-current]="cell.today ? 'date' : null"
              [attr.data-mib-date]="cell.key"
              (click)="pick(cell)"
              (pointerenter)="hovered.set(cell.day)"
              (keydown)="onKeydown($event, cell)"
              (focus)="onFocus(cell)">
              <span
                class="flex size-8 items-center justify-center rounded-full text-sm group-focus-visible:outline-2 group-focus-visible:outline-offset-1 group-focus-visible:outline-mib-primary"
                aria-hidden="true"
                [class.bg-mib-primary]="cell.selected"
                [class.text-white]="cell.selected"
                [class.font-semibold]="cell.today || cell.selected"
                [class.border]="(cell.today || cell.preview) && !cell.selected"
                [class.border-dashed]="cell.preview"
                [class.border-mib-primary]="(cell.today || cell.preview) && !cell.selected"
                [class.text-mib-primary]="!cell.selected && !cell.disabled && (cell.today || cell.inRange)"
                [class.text-gray-900]="!cell.selected && !cell.disabled && !cell.today && !cell.inRange"
                [class.text-gray-500]="cell.disabled"
                [class.line-through]="cell.disabled"
                [class.hover:bg-gray-100]="!cell.selected && !cell.disabled && !cell.inRange"
                >{{ cell.day.getDate() }}</span
              >
            </div>
          } @else {
            <div ngGridCell [disabled]="true" class="h-9" aria-hidden="true"></div>
          }
        }
      </div>
    }
  </div>
}
